/* eslint-disable no-shadow */
import Stripe from '../../api/stripe';

// initial state
const state = {
  publishKey: null,
  planPro: null,
  planEssentials: null
};

// getters - all receive state as first argument
const getters = {
  getPublishKey: (state) => state.publishKey,
  getPlanPro: (state) => state.planPro,
  getPlanEssentials: (state) => state.planEssentials
};

// actions
const actions = {
  async getPublishKey({commit}) {
    commit('setPublishKey', await Stripe.getPublishKey());
  },
  async getPlanPro({commit}) {
    commit('setPlanPro', await Stripe.getPlan('pro'));
  },
  async getPlanEssentials({commit}) {
    commit('setPlanEssentials', await Stripe.getPlan('essentials'));
  }
};

// mutations
const mutations = {
  setPublishKey(state, publishKey) {
    state.publishKey = publishKey;
  },
  setPlanPro(state, plan) {
    state.planPro = plan;
  },
  setPlanEssentials(state, plan) {
    state.planEssentials = plan;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
